
import { Helmet } from "react-helmet";

 interface HeaderProps{
  title:string,
  description:string
}
export default function HeaderInfos({title,description}:HeaderProps){
  if (!title) console.warn("HeaderInfos: title is undefined");    return(
      <>
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
        </Helmet>
      </>
        
    )
}